var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconImportJob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21V13L8 17",
    stroke: "#2783EC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13L16 17",
    stroke: "#2783EC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.393 15.2686C3.57626 14.5541 2.93682 13.6595 2.52517 12.6555C2.11351 11.6515 1.94092 10.5655 2.02102 9.48329C2.10112 8.40111 2.43172 7.35237 2.98671 6.41989C3.5417 5.48741 4.30588 4.69673 5.21891 4.11028C6.13194 3.52384 7.1688 3.15769 8.24763 3.04076C9.32645 2.92383 10.4177 3.05931 11.4352 3.43651C12.4526 3.81371 13.3685 4.4223 14.1104 5.21422C14.8523 6.00613 15.3999 6.95968 15.71 7.99957H17.5C18.4721 7.99945 19.418 8.31409 20.1964 8.89643C20.9747 9.47876 21.5435 10.2975 21.8178 11.23C22.092 12.1626 22.0569 13.1589 21.7177 14.0699C21.3785 14.9809 20.7534 15.7575 19.936 16.2836",
    stroke: "#2783EC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImportJob);
export default __webpack_public_path__ + "static/media/icon-import-job.d1f79dfbc01995490258398836ea68f0.svg";
export { ForwardRef as ReactComponent };